import { observable } from 'mobx';
import NetworkSpeedService from '../utils/is-online';
import {getRouterBasename} from '../utils/get-router-basename';
import RootStore from './root-store';

const CLASS_OFFLINE = 'offline';
const CLASS_SLOW_NETWORK = 'slow-network';
const routerBasename = getRouterBasename();

export const NETWORK_EVENT = {
  CONNECTION_ERROR: 'connectionError',
  CONNECTION_GOOD: 'connectionGood',
  CONNECTION_SLOW: 'connectionSlow',
};

class ConnectionStore {
  rootStore: RootStore;

  @observable isOnline: boolean = true;
  @observable isSlow: boolean = false;
  @observable service: NetworkSpeedService | null = null;
  @observable simulateOffline: boolean = false;

  constructor (rootStore: RootStore) {
    this.rootStore = rootStore;
    this.init();
  }

  init() {
    this.service = new NetworkSpeedService({
      pingUrl: `${routerBasename}/connection.gif`,
      slowNetwork: () => {
        if (this.simulateOffline) {
          return this._setOffline();
        }
        this.isSlow = true;
        document.body.classList.remove(CLASS_OFFLINE);
        document.body.classList.add(CLASS_SLOW_NETWORK);
        this.fireEvent(NETWORK_EVENT.CONNECTION_SLOW);
      },
      offline: () => {
        this._setOffline();
      },
      online: () => {
        if (this.simulateOffline) {
          return this._setOffline();
        }
        this._setOnline();
      },
    });
  }

  _setOffline() {
    this.isOnline = false;
    this.isSlow = false;
    document.body.classList.remove(CLASS_SLOW_NETWORK);
    document.body.classList.add(CLASS_OFFLINE);
    this.fireEvent(NETWORK_EVENT.CONNECTION_ERROR);
  }

  _setOnline() {
    this.isOnline = true;
    this.isSlow = false;
    this.fireEvent(NETWORK_EVENT.CONNECTION_GOOD);
    document.body.classList.remove(CLASS_OFFLINE, CLASS_SLOW_NETWORK);
  }

  check() {
    if (this.service) {
      this.service.check();
    }
  }

  fireEvent(name: string): void {
    const event = new Event(name, {
      bubbles: true,
      cancelable: true,
    });

    window.dispatchEvent(event);
  }

  toggleOffline() {
    this.simulateOffline = !this.simulateOffline;
  }
}

export default ConnectionStore;
